import { RootState } from '@/shared/store'
import { runsheetShiftsAdapter } from '../adapters/runsheetShiftsAdapter'

export const runsheetShiftsSelectors = runsheetShiftsAdapter.getSelectors<RootState>(
  (state) => state.runsheetShifts,
)
